import { state } from './state.js';

export const utils = {
  showFeedback(msg, type = 'info') {
    const el = state.elements.feedbackEl;
    if (!el) return;
    el.textContent = msg;
    el.className = 'acpb-feedback ' + type;
  },

  updateTotal() {
    const selections = state.getSelections();
    const baseTotal = state.steps.reduce((sum, step) => {
      const sel = selections[step.id];
      return sum + (sel?.price || 0);
    }, 0);

    const qty = parseInt(state.elements.qtyInput.value, 10) || 1;
    const total = baseTotal * qty;

    const target = state.root.querySelector('#acpb-total-price');
    if (target) target.textContent = total.toFixed(2) + ' €';
  },

  stripHtml(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  },

  updateAddButtonState() {
    const selections = state.getSelections();
    const addBtn = state.elements.addBtn;
    if (!addBtn) return;

    const missingRequired = state.steps.some(s => s.required && !selections[s.id]);
    const empty = Object.values(selections).length === 0;

    const isOut = Object.values(selections).some(sel =>
      sel?.type === 'product' && sel.stock === 0
    );

    if (missingRequired || empty || isOut) {
      addBtn.disabled = true;
      addBtn.classList.add('acpb-disabled');
    } else {
      addBtn.disabled = false;
      addBtn.classList.remove('acpb-disabled');
    }
  },

  mergePreviewLayers() {
    const preview = state.elements.previewEl;
    const layers = [...preview.querySelectorAll('img.acpb-layer')]
      .filter(i => i.naturalWidth && i.naturalHeight);

    if (!layers.length) return null;

    const w = layers[0].naturalWidth;
    const h = layers[0].naturalHeight;

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');

    layers.forEach(img => {
      try { ctx.drawImage(img, 0, 0, w, h); }
      catch (e) { console.warn('Image ignorée :', img.src); }
    });

    return canvas.toDataURL('image/png');
  },

  async savePreview(img, data) {
    const url = prestashop.urls.base_url + 'module/ac_packbuilder/savepreview';
    const form = new FormData();
    form.append('image_base64', img || '');
    form.append('json_data', JSON.stringify(data));

    const res = await fetch(url, { method: 'POST', body: form, credentials: 'same-origin' });
    return res.json();
  },

  async addToCart(idProduct, qty, idPa) {
    const root = state.root;

    const form = new FormData();
    form.append('controller', 'cart');
    form.append('add', '1');
    form.append('id_product', idProduct);
    if (idPa) form.append('id_product_attribute', idPa);
    form.append('qty', qty);
    form.append('ajax', '1');
    form.append('action', 'update');

    const url = root.dataset.cartUrl ||
      prestashop.urls.pages.cart ||
      '/index.php?controller=cart';

    if (root.dataset.cartToken) form.append('token', root.dataset.cartToken);

    const res = await fetch(url, { method: 'POST', body: form, credentials: 'same-origin' });
    return res.json();
  },

  async getStock(idProduct, idPA) {
    const url = `${prestashop.urls.base_url}module/ac_packbuilder/stock?id_product=${idProduct}&id_product_attribute=${idPA || 0}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    return res.json();
  }
};
